export default "__VITE_ASSET__78AQJpnJ__"